const formControlLabelModalPlace = {
  business: 'Rama',
  room: 'Hoja'
};

export default formControlLabelModalPlace;
